import { useRuntimeConfig } from 'nuxt/app';

function cdnAssetPath(
   nonDomainUrl: string | undefined,
   useBucketInsteadOfCloudfront = false,
   version?: string,
): string {
   const baseUrl = (!useBucketInsteadOfCloudfront
      ? useRuntimeConfig().public.cdnAssetsPath
      : useRuntimeConfig().public.bucketAssetsPath) as string;

   // Return base URL (without trailing slash) if path is undefined or null
   if (nonDomainUrl === undefined || nonDomainUrl === null) {
      return baseUrl.replace(/\/$/, '');
   }

   // If the path is already a full URL, return it as-is
   if (nonDomainUrl.startsWith('http://') || nonDomainUrl.startsWith('https://')) {
      return nonDomainUrl;
   }

   // Ensure base URL does not end with a slash
   const cleanBaseUrl = baseUrl.replace(/\/$/, '');
   // Ensure path starts with a slash
   const cleanPath = nonDomainUrl.startsWith('/')
      ? nonDomainUrl
      : `/${nonDomainUrl}`;

   const fullUrl = `${cleanBaseUrl}${cleanPath}`;

   // Append version query parameter for cache busting if provided
   if (version) {
      return `${fullUrl}?v=${version}`;
   }

   return fullUrl;
}

export default cdnAssetPath;
